import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";

export const editBank = createAsyncThunk(
    '/add/editBank',
    async (edit) => {

        try {
            const myurl = `${PAY_URL}/admin/manage-bank`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: edit,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_ADMIN_TOKEN')
                },
            });

            const editBank = response.data;
            // console.log(editBank, '@@@')

            if (editBank.success === true) {
                toast.success(editBank?.message);
                return editBank;
            } else {
                // console.log(editBank.message, "&&&&")
                throw new Error(editBank.message);
            }
        } catch (error) {
            console.log(error, "!!!!")
            toast.error(error.response.data.message);
            return error;
        }
    }
);


const editBankSlice = createSlice({
    name: "editBank",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(editBank.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(editBank.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(editBank.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default editBankSlice.reducer;